import {
	bacon,
	boulettedeviande,
	chorizo,
	kebab,
	merguez,
	salami,
	steakhache,
	viandehachee,
	viandeseche,
	viandesechebresaola,
} from '../assets'
const charcuterieData = [
	{
		id: 1,
		name: 'Steak haché',
		img: steakhache,
		price: '16.000',
		description: `Le steak haché de FARAH vous fait découvrir l’exquise du goût délicieux en gardant son fondant à cœur quel que soit sa cuisson (Poêle, barbecue..).
        Une recette reproduite fidèlement depuis des générations, respecte le sens de la fibre au hachage et restitue la texture aérée du bœuf haché. Ainsi travaillée, la viande peut être poêlée en quelques minutes et offrir ses bienfaits sans contrainte. Un plaisir qui prend soin de votre famille avec sa richesse naturelle en protéines, vitamines et minéraux.`,
	},
	{
		id: 2,
		name: 'Merguez maison',
		img: merguez,
		price: '16.500',
		description: `Viande bovine finement hachée mélangée avec des épices puis embossée dans des boyaux de mouton, des mini merguez d’une longueur de 4 cm.
        Idéales pour des brochettes et des tapas.`,
	},
	{
		id: 3,
		name: 'Boulette de viande',
		img: boulettedeviande,
		price: '16.000',
		description: `Les boulettes de viande sont une manière de préparer la viande en boulettes, qui se rencontre partout dans le monde. Elles sont préparées le plus couramment à partir de bœuf ou de porc, mais d'autres viandes sont également utilisées`,
	},
	{
		id: 4,
		name: 'Kebab 100g',
		img: kebab,
		price: '16.000',
		description: `description`,
	},
	{
		id: 5,
		name: 'Viande haché',
		img: viandehachee,
		price: '17.000',
		description: `description`,
	},
	{
		id: 6,
		name: 'Chorizo',
		img: chorizo,
		price: '18.000',
		description: `description`,
	},
	{
		id: 7,
		name: 'Bacon',
		img: bacon,
		price: '35.000',
		description: `description`,
	},
	{
		id: 8,
		name: 'Viande seché',
		img: viandeseche,
		price: '43.000',
		description: `description`,
	},
	{
		id: 9,
		name: 'Viande seché bresaola',
		img: viandesechebresaola,
		price: '35.000',
		description: `description`,
	},
	{
		id: 10,
		name: 'Salami traditionnel',
		img: salami,
		price: '16.200',
		description: `description`,
	},
]
export default charcuterieData
